
<template>
  <v-card class="mx-auto">
    <vdata-table :data="filteredGroups" :headers="headers"> </vdata-table>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    groupId: String,
  },
  data() {
    return {
      categories: [],
      totalCount: 0,
      headers: [
        {
          text: "ID",
          align: "start",
          filterable: false,
          value: "id",
        },
        {
          text: "Parent Category Id",
          sortable: true,
          value: "parentCategoryId",
        },
        {
          text: "Parent Category Name",
          sortable: true,
          value: "parentCategoryId",
        },
        { text: "Name", sortable: true, value: "name" },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "right",
          divider: false,
          width: 160,
        },
      ],
    };
  },
  async created() {
    console.log("categories are refreshing due to creating");
    await this.refreshTable();
  },
  computed: {
    ...mapGetters({ items: "category/items" }),

    filteredGroups() {
      if (this.groupId != "") {
        return this.items.filter((g) => g.parentCategoryId == this.groupId);
      }
      return this.items;
    },
  },
  methods: {
    ...mapActions(["category/getItems"]),

    async refreshTable() {
      console.log("cat table refresh");
      console.log("groupid", this.groupId);
      console.log("items", this.items);
      console.log(
        "items",
        this.items.filter((g) => g.parentCategoryId == this.groupId)
      );
      this.$store.dispatch("category/getItems", this.groupId);
    },
  },
  watch: {
    groupId() {
      this.$emit("update:groupId", this.groupId);
      this.refreshTable();
    },
  },
};
</script>